import {
  Component,
  OnInit,
  OnDestroy,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ActivatedRoute, Router } from '@angular/router';
import { LoanAiService, TenantItem } from '../loanAiService';
import { DUMMY_PAYLOADS } from '../constant';
import { environment } from '../../environments/environment';
import { LayoutService } from '../_services/layout.service';
import { MappingResultService } from '../_services/mapping-result.service';
import {
  MotifFormsModule,
  MotifModal,
  MotifModalModule,
  MotifTableCellRendererComponent,
  MotifTableHeaderRendererComponent,
  MotifTableModule,
  MotifTooltipModule,
} from '@ey-xd/ng-motif';
import {
  MotifButtonModule,
  MotifIconModule,
  MotifToastModule,
} from '@ey-xd/ng-motif';
import {
  IconoirDatabaseBackup,
  IconoirCustomPageLast,
  IconoirEdit,
  IconoirCustomTaskList,
  IconoirDocMagnifyingGlassIn,
  MotifFileIcFileDownload24px
} from '@ey-xd/motif-icon';
import { AssetClassCellRendererComponent } from '../_shared/asset-class-cell-renderer/asset-class-cell-renderer.component';
import { AssetClassCellEditorComponent } from '../_shared/asset-class-cell-editor/asset-class-cell-editor.component';
import {
  ICellComp,
  CellValueChangedEvent,
  ICellEditorParams,
  HeaderCellCtrl,
} from 'ag-grid-community';
import { ConfirmCommonComponent } from '../_dialog/confirm-common/confirm-common.component';
import { ConfirmStopComponent } from '../_dialog/confirm-stop/confirm-stop.component';
import { interval, Subscription } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { ProfileService } from '../_services/profile.service';

// an enum for the type of toast
export enum ToastType {
  Success = 'success',
  Error = 'error',
  Info = 'info',
  Warning = 'warning',
}

interface ObligorStatus {
  doc_run_id: string;
  step_status: string;
  total_elements: number;
  completed_elements: number;
  failed_elements: number;
  completed_percentage: number;
}

interface IViewApiResponse {
  obligor_name: string;
  sub_product_type: string;
  doc_run_id: string;
  asset_class: string;
  request_id: string;
  step_status: string;
}

@Component({
  selector: 'app-view-details',
  imports: [
    MatTableModule,
    MatIconModule,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    CommonModule,
    MotifTableModule,
    MotifButtonModule,
    MotifIconModule,
    MotifToastModule,
    MotifModalModule,
    MotifTooltipModule,
    MotifFormsModule
  ],
  standalone: true,
  templateUrl: './view-details.component.html',
  styleUrls: ['./view-details.component.scss'],
})
export class ViewDetailsComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = [
    'facility',
    'borrower',
    'subproduct',
    'runstatus',
    'asset',
    'actions',
  ];
  quarter: any;
  year: any;
  dataSource: any;
  totalCount: number = 0;
  displayedDataSource: any;
  attributeReqId: any;
  docIds: any;
  assets: any;
  products: any;
  selectedProduct = false;
  selectedProductValue: any = null;
  allAssetAvailable = false;
  client_name: any;
  private tenantsFull: TenantItem[] = [];
  private tenantsSub: Subscription | undefined;
  private tenantIdSub: Subscription | undefined;
  extractionInProgress: boolean = false;
  obligorsStatus: ObligorStatus[] = [];

  pagesize: number = 10;
  currentPageIndex: number = 0;
  initialPageIndex: number | null = null;
  columnDefs: any;
  @ViewChild('actionsTemplate') actionsTemplate!: TemplateRef<any>;
  @ViewChild('docRunIdTemplate') docRunIdTemplate!: TemplateRef<any>;
  @ViewChild('obligorNameTemplate') obligorNameTemplate!: TemplateRef<any>;
  @ViewChild('subProductTypeTemplate') subProductTypeTemplate!: TemplateRef<any>;
  @ViewChild('createdByTemplate') createdByTemplate!: TemplateRef<any>;
  @ViewChild('createdAtTemplate') createdAtTemplate!: TemplateRef<any>;
  @ViewChild('assetClassTemplate') assetClassTemplate!: TemplateRef<any>;
  @ViewChild('extractionStatusTemplate')
  extractionStatusTemplate!: TemplateRef<any>;
  gridOptions: any = {
    // theme: 'legacy',
    onCellEditingStarted: (event: any) => this.pausePolling(),
    onCellEditingStopped: (event: any) => this.resumePolling(),
    onGridReady: (params: any) => {
      this.gridApi = params.api;
      setTimeout(() => this.attemptRestorePage(), 0);
    },
    onPaginationChanged: () => {
      if (this.gridApi && this.gridApi.paginationGetCurrentPage) {
        const newIndex = this.gridApi.paginationGetCurrentPage();
        if (newIndex !== this.currentPageIndex) {
          this.currentPageIndex = newIndex;
          this.updatePageInUrl();
        }
      }
    }
  };
  private gridApi: any;
  toastType: ToastType = ToastType.Info;
  showToast: boolean = false;
  // button icons
  iconoirCustomPageLast = IconoirCustomPageLast;
  iconoirCustomTaskList = IconoirCustomTaskList;
  iconoirDocMagnifyingGlassIn = IconoirDocMagnifyingGlassIn;
  iconoirEdit = IconoirEdit;
  iconoirDatabaseBackup = IconoirDatabaseBackup;
  motifFileIcFileDownload24px = MotifFileIcFileDownload24px;
  ToastType: any;
  type: any;
  toastMessage: string = '';
  csvDownloading: boolean = false;

  // Polling mechanism properties
  private pollingMap: Map<string, { subscription: Subscription; docIds: Set<string> }> = new Map();
  private isComponentActive = true;
  private isAssetClassEditing = false;
  private inProgressTracking: Map<string, { lastPercent: number; lastIncreaseAt: number }> = new Map();
  public confirmationModal: boolean = false;
  updatedRow: any = '';
  newAssetValue: any;
  searchQuery: string = '';
  private hadQueryParamSearch: boolean = false;
  // Plain modal state for required docs (not using Motif)
  showRequiredDocsModal: boolean = false;
  requiredModalCategories: string[] = [];
  requiredModalObligor: string | null = null;
  // Keep reference to the row that triggered the required-docs modal
  requiredModalRow: IViewApiResponse | null = null;
  showDownloadConfirmModal: boolean = false;

  ngOnInit(): void {
    // show sidenav
    this.layoutService.displaySideNav(true);

this.service.viewDetails(this.year, this.quarter).subscribe((data) => {
  // Guard: ensure data.obligors is an array before using spread or indexing
  this.dataSource = Array.isArray(data?.obligors) ? data.obligors : [];
  this.displayedDataSource = Array.isArray(this.dataSource) ? [...this.dataSource] : [];
  this.totalCount = this.displayedDataSource.length; // Initialize totalCount with the total items
  this.attributeReqId = Array.isArray(data?.obligors) && data.obligors.length > 0 ? data.obligors[0].request_id : undefined;
  // Announce initial request id for each obligor so mapping-result (if already open) can sync
  try {
    if (Array.isArray(data.obligors)) {
      data.obligors.forEach((o: any) => {
        if (o && o.doc_run_id && o.request_id) {
          this.mappingResultService.announceRequestId(o.doc_run_id, o.request_id);
        }
      });
    }
  } catch (e) { /* ignore */ }
  try {
      if (Array.isArray(this.dataSource)) {
      this.dataSource.forEach((row: any) => {
        const latest = this.mappingResultService.getLatestRequestId(row.doc_run_id);
        if (latest && latest !== row.request_id) {
          row.request_id = latest;
          row.step_status = 'IN_PROGRESS';
        }
      });
      this.dataSource = Array.isArray(this.dataSource) ? [...this.dataSource] : [];
    }
  } catch (e) { /* ignore */ }
  this.getDocRunIdsFromObligors(data.obligors);
  this.checkForAsset(data.obligors);
  this.checkExtractionInprogress();
  if (this.searchQuery && this.searchQuery.trim().length > 0) {
    this.applyFilter();
  }
  setTimeout(() => this.attemptRestorePage(), 0);
});

    this.service.fetchAllProducts().subscribe((data) => {
      this.products = data.product_lst;
    });

    this.service.fetchAllAssets().subscribe((data) => {
      this.assets = data.assetclass_lst;
    });
    if (!this.hadQueryParamSearch) {
      this.loadPersistedSearch();
    }

    // Subscribe to extraction triggers coming from mapping-result (Update Results)
    // NOTE: updateReRunResults() emits extractionTrigger with extractionTriggeredByUpdateResults=true
    // In that case we SHOULD NOT call the local runIndividualExtractionTriggered() which performs
    // a runSingleExtraction API call. requestIdUpdates (below) already handles switching
    // request_id and starting polling for re-run flows. Only call runIndividualExtractionTriggered
    // for external/manual triggers where extractionTriggeredByUpdateResults is falsy.
    this.mappingResultService.extractionTrigger.subscribe((payload) => {
      if (!payload || !payload.doc_run_id) return;
      // If this trigger was emitted as a result of Update Results, ignore here
      // to avoid calling the runSingleExtraction API again. requestIdUpdates will
      // arrive (or announceRequestId will be used) to start polling.
      if (payload.extractionTriggeredByUpdateResults) return;
      // find matching row
      const row = this.dataSource?.find((d: any) => d.doc_run_id === payload.doc_run_id);
  if (!row) return;
  // This ensures the same behavior as clicking the "Run Individual Extraction" button.
  this.runIndividualExtractionTriggered(row, true);
    });

    // Subscribe to requestIdUpdates so we catch new request ids even if extractionTrigger was missed
    this.mappingResultService.requestIdUpdates.subscribe((u) => {
      if (!u || !u.doc_run_id || !u.request_id) return;
      const row = this.dataSource?.find((d: any) => d.doc_run_id === u.doc_run_id);
      if (!row) return;
      if (row.request_id !== u.request_id) {
        try { this.removeDocFromPolling(u.doc_run_id); } catch (e) { /* ignore */ }
        row.request_id = u.request_id;
        row.step_status = 'IN_PROGRESS';
        row.created_by = this.profileService.getUserEmail();
        this.dataSource = Array.isArray(this.dataSource) ? [...this.dataSource] : [];
        this.startPolling(u.request_id, [u.doc_run_id]);
      }
    });

      // if (environment.production) {
      //   this.client_name = 'NexBank';
      // } else {
      //   this.client_name = DUMMY_PAYLOADS[0].client_name;
      // }
      // subscribe to tenants list to resolve names
      try {
        this.tenantsSub = this.service.tenants$.subscribe((tenants: TenantItem[]) => {
          this.tenantsFull = tenants || [];
          const saved = localStorage.getItem('tenantId') || '';
          const matched = this.tenantsFull.find(t => t.tenant_guid === saved);
          if (matched && matched.tenant_name) {
            this.client_name = matched.tenant_name;
          }
        });
        this.tenantIdSub = this.service.tenantId$.subscribe((tenantId) => {
          const matched = this.tenantsFull.find(t => t.tenant_guid === tenantId);
          if (matched && matched.tenant_name) {
            this.client_name = matched.tenant_name;
          }
        });
      } catch (e) { /* ignore */ }
  }

  // Open the download confirmation modal
  openDownloadConfirm() {
    // If a download is already in progress, do nothing
    if (this.csvDownloading) return;
    this.showDownloadConfirmModal = true;
  }

  // User confirmed the download - call the actual downloadCsv method
  confirmDownload() {
    this.showDownloadConfirmModal = false;
    // call the existing downloadCsv which handles csvDownloading flag
    this.downloadCsv();
  }

  // Cancel the download confirmation
  cancelDownload() {
    this.showDownloadConfirmModal = false;
  }

applyFilter() {
  if (!this.dataSource) {
    this.displayedDataSource = [];
    this.totalCount = 0; // Update total count
    return;
  }
  const q = (this.searchQuery || '').trim().toLowerCase();
  if (!q) {
    this.displayedDataSource = [...this.dataSource];
    this.totalCount = this.displayedDataSource.length; // Reset total count to original total items
    setTimeout(() => {
      if (this.gridApi && this.gridApi.paginationGoToPage) {
        try {
          this.gridApi.paginationGoToPage(0);
          this.currentPageIndex = 0;
          this.updatePageInUrl(true);
        } catch (e) {
          // ignore any pagination timing errors
        }
      }
    }, 0);
    return;
  }
  this.displayedDataSource = this.dataSource.filter((r: any) => {
    return (
      (r.obligor_name || '').toString().toLowerCase().includes(q)
    );
  });
  this.totalCount = this.displayedDataSource.length; // Update total count based on filtered items
  setTimeout(() => {
    if (this.gridApi && this.gridApi.paginationGoToPage) {
      try {
        this.gridApi.paginationGoToPage(0);
        this.currentPageIndex = 0;
        this.updatePageInUrl(true);
      } catch (e) {
        // ignore any pagination timing errors
      }
    }
  }, 0);
}

getExtractionDisplayStatus(status: string): string {
  if (!status) return '';
  const map: Record<string, string> = {
      'FAILED': 'Failed',
      'CANCELLED': 'Cancelled',
      'PARTIAL_COMPLETED': 'Partial Completed',
      'COMPLETED': 'Completed',
      'PENDING': 'Pending',
      'IN_PROGRESS': 'In Progress',
      'completed': 'Completed',
  };
  return map[status] || map[status?.toUpperCase()] || status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
}

  onSearchChange() {
    this.applyFilter();
    this.updateSearchInUrl();
    this.persistSearch();
  }

  // Run individual extraction without confirmation modal (used when triggered programmatically)
  runIndividualExtractionTriggered(row: any, triggeredByUpdateResults?: boolean) {
    if (!row) return;
    this.allAssetAvailable = false;
    this.selectedProduct = false;
    this.extractionInProgress = true;

    // Immediate UI feedback
    const rowToUpdate = Array.isArray(this.dataSource) ? this.dataSource.find((d: any) => d.doc_run_id === row.doc_run_id) : undefined;
    if (rowToUpdate) {
      rowToUpdate.step_status = 'IN_PROGRESS';
      rowToUpdate.created_by = this.profileService.getUserEmail();
      this.dataSource = Array.isArray(this.dataSource) ? [...this.dataSource] : [];
    }

    this.service
      .runSingleJobExtraction(this.year, this.quarter, row.doc_run_id, row.obligor_name, row.sub_product_type)
      .subscribe((data) => {
        this.attributeReqId = data.request_id;
        // Announce new request id for this doc_run_id immediately
        try { this.mappingResultService.announceRequestId(row.doc_run_id, data.request_id); } catch (e) {}
        this.isComponentActive = true;
        if (data.obligors && Array.isArray(data.obligors)) {
          const apiObligor = data.obligors.find((o: any) => o.doc_run_id === row.doc_run_id);
          if (apiObligor && apiObligor.created_by && rowToUpdate) {
            rowToUpdate.created_by = apiObligor.created_by;
          }
        }
        try { this.removeDocFromPolling(row.doc_run_id); } catch (e) { /* ignore */ }
        this.startPolling(data.request_id, [row.doc_run_id]);
      });
  }

  getDocRunIdsFromObligors(obligors: IViewApiResponse[]) {
    // Loop over obligors and if any step_status is 'IN_PROGRESS', call startPolling with requestId and docIds from each object
    if (Array.isArray(obligors)) {
      obligors.forEach((obligor: IViewApiResponse) => {
        if (obligor.step_status === 'IN_PROGRESS') {
          this.startPolling(obligor.request_id, [obligor.doc_run_id]);
        }
      });
    }
  }

  ngOnDestroy(): void {
    // Clean up all active polling subscriptions when component is destroyed
    this.isComponentActive = false;
    this.pollingMap.forEach(({ subscription }) => {
      try { subscription.unsubscribe(); } catch (e) { /* ignore */ }
    });
    this.pollingMap.clear();
    try { if (this.tenantsSub) this.tenantsSub.unsubscribe(); } catch (e) {}
    try { if (this.tenantIdSub) this.tenantIdSub.unsubscribe(); } catch (e) {}
  }

  startPolling(request_id: string, docIds: string[]) {
    // Merge docIds if polling already exists for this request_id
    const existing = this.pollingMap.get(request_id);
    if (existing) {
      docIds.forEach(id => existing.docIds.add(id));
      docIds.forEach(id => this.initInProgressTracking(id));
      return; // Avoid creating duplicate subscription
    }

    const docIdSet = new Set(docIds);
    docIds.forEach(id => this.initInProgressTracking(id));
    const subscription = interval(5000)
      .pipe(takeWhile(() => this.isComponentActive))
      .subscribe(() => {
        if (this.isAssetClassEditing) return;
        const idsArray = Array.from(docIdSet);
        if (idsArray.length === 0) return;
        this.service
        .pollExtractionStatus(request_id, idsArray)
        .subscribe((data) => {
          const stopPollingDocIds: string[] = [];
          if (Array.isArray(data.obligors)) {
            data.obligors.forEach((status: any) => {
              const row = this.dataSource.find((d: any) => d.doc_run_id === status.doc_run_id);
              if (row) {
                  const prevStatus = row.step_status;
                  row.completed_percentage = status.completed_percentage;
                  row.created_by = status.created_by;
                  if (status.created_at) {
                    row.created_at = status.created_at;
                  }
                  if (row.completed_percentage === 100) {
                    row.step_status = 'COMPLETED';
                  } else {
                    row.step_status = status.step_status;
                  }
                  if (prevStatus !== 'COMPLETED' && row.step_status === 'COMPLETED') {
                    try { this.mappingResultService.notifyExtractionCompleted(row.doc_run_id); } catch (e) { /* ignore */ }
                    this.refreshRowUI(row.doc_run_id);
                  }
                  const normalizedStatus = (status.step_status || '').toString().toUpperCase();
                  const completedPercent = typeof status.completed_percentage === 'number'
                    ? status.completed_percentage
                    : (typeof row.completed_percentage === 'number' ? row.completed_percentage : 0);
                  if (normalizedStatus === 'IN_PROGRESS') {
                    if (this.shouldStopPollingForInProgress(status.doc_run_id, completedPercent)) {
                      stopPollingDocIds.push(status.doc_run_id);
                    }
                  } else {
                    this.clearInProgressTracking(status.doc_run_id);
                  }
                }
            });
            this.dataSource = Array.isArray(this.dataSource) ? [...this.dataSource] : [];
            this.displayedDataSource = Array.isArray(this.dataSource) ? [...this.dataSource] : [];
            this.refreshGridCells();
          }
          if (stopPollingDocIds.length > 0) {
            stopPollingDocIds.forEach((docRunId) => this.removeDocFromPolling(docRunId));
          }
          this.checkExtractionInprogress();
          // If all tracked docIds for this request are COMPLETED, stop polling for this request_id
          const allComplete = Array.from(docIdSet).every(docRunId => {
            const r = this.dataSource.find((d: any) => d.doc_run_id === docRunId);
            return r && r.step_status === 'COMPLETED';
          });
          if (allComplete) {
            try { subscription.unsubscribe(); } catch (e) { /* ignore */ }
            this.pollingMap.delete(request_id);
          }
        });
      });

    this.pollingMap.set(request_id, { subscription, docIds: docIdSet });
  }

  private initInProgressTracking(docRunId: string) {
    if (!docRunId || this.inProgressTracking.has(docRunId)) return;
    const row = Array.isArray(this.dataSource)
      ? this.dataSource.find((d: any) => d.doc_run_id === docRunId)
      : undefined;
    const initialPercent = typeof row?.completed_percentage === 'number'
      ? row.completed_percentage
      : 0;
    this.inProgressTracking.set(docRunId, {
      lastPercent: initialPercent,
      lastIncreaseAt: Date.now(),
    });
  }

  private clearInProgressTracking(docRunId: string) {
    if (!docRunId) return;
    this.inProgressTracking.delete(docRunId);
  }

  private shouldStopPollingForInProgress(docRunId: string, completedPercent: number): boolean {
    const timeoutMs = 300 * 60 * 1000;
    const minIncrease = 1;
    const now = Date.now();
    const tracking = this.inProgressTracking.get(docRunId);
    if (!tracking) {
      this.inProgressTracking.set(docRunId, {
        lastPercent: completedPercent,
        lastIncreaseAt: now,
      });
      return false;
    }

    if (completedPercent - tracking.lastPercent >= minIncrease) {
      tracking.lastPercent = completedPercent;
      tracking.lastIncreaseAt = now;
      return false;
    }

    return now - tracking.lastIncreaseAt >= timeoutMs;
  }

  checkExtractionInprogress() {
    // go through the dataSource and check if any of the step_status is 'IN_PROGRESS'
    this.extractionInProgress = this.dataSource.some(
      (d: any) => d.step_status === 'IN_PROGRESS'
    );
    // If all step_status are 'COMPLETED', set isComponentActive to true
    if (this.dataSource.every((d: any) => d.step_status === 'COMPLETED')) {
      this.isComponentActive = false;
    }
  }

  pausePolling() {
    // Set flag to pause polling during asset class editing
    this.isAssetClassEditing = true;
    // console.log('Polling paused during asset class editing');
  }

  resumePolling() {
    // Resume polling after asset class editing is complete
    this.isAssetClassEditing = false;
    // console.log('Polling resumed after asset class editing');
  }

  private refreshGridCells() {
    try {
      if (this.gridApi && this.gridApi.refreshCells) {
        this.gridApi.refreshCells({ force: true, suppressFlash: true });
      }
    } catch (e) { /* ignore */ }
  }

  private refreshRowUI(docRunId: string) {
    try {
      this.refreshGridCells();
    } catch (e) { /* ignore */ }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.columnDefs = [
        {
          headerComponentFramework: MotifTableHeaderRendererComponent,
          headerName: 'Borrower Name',
          field: 'obligor_name',
          filter: true,
          flex: 3,
          unSortIcon: true,
            cellRenderer: MotifTableCellRendererComponent,
            cellRendererParams: {
              ngTemplate: this.obligorNameTemplate,
            },
            cellClass: 'truncate-cell',
          // maxWidth: 180,
          width: 180,
        },
        {
          headerComponentFramework: MotifTableHeaderRendererComponent,
          headerName: 'Facility Type',
          field: 'sub_product_type',
          filter: false,
          flex: 3,
          unSortIcon: true,
            cellRenderer: MotifTableCellRendererComponent,
            cellRendererParams: {
              ngTemplate: this.subProductTypeTemplate,
            },
            cellClass: 'truncate-cell',
          // maxWidth: 120,
          width: 120,
          cellStyle: { 'padding-right': '0px' },
          pinned: 'fixed',
        },
        {
          headerComponentFramework: MotifTableHeaderRendererComponent,
          cellRenderer: MotifTableCellRendererComponent,
          cellRendererParams: {
            ngTemplate: this.extractionStatusTemplate,
          },
          headerName: 'Extraction Status',
          field: 'step_status',
          filter: false,
          flex: 2,
          unSortIcon: true,
          cellClass: 'truncate-cell',
          // maxWidth: 200,
          width: 200,
        },
        {
          headerComponentFramework: MotifTableHeaderRendererComponent,
          cellRenderer: AssetClassCellRendererComponent,
          cellRendererParams: (params: any) => ({
            assets: this.assets,
          }),
          // cellRenderer: MotifTableCellRendererComponent,
          // cellRendererParams: {
          //   ngTemplate: this.assetClassTemplate,
          // },

          cellEditor: AssetClassCellEditorComponent,
          cellEditorParams: (params: ICellEditorParams) => ({
            assets: this.assets,
            isDisabled: params.data?.step_status === 'IN_PROGRESS',
          }),
          editable: (params: any) => {
            const status = params.data?.step_status;
            return (
              status === 'PENDING' ||
              status === 'FAILED' ||
              status === 'COMPLETED' ||
              status === 'CANCELLED'
            );
          },
          cellClassRules: {
            'disabled-cell': (params: any) =>
              params.data?.step_status === 'IN_PROGRESS', // Only disable for IN_PROGRESS
            // Ensure asset class cell is enabled for CANCELLED
            'enabled-cell': (params: any) =>
              params.data?.step_status === 'CANCELLED',
          },
          headerName: 'Asset Class',
          field: 'asset_class',
          filter: false,
          flex: 2,
          unSortIcon: true,
          cellClass: 'truncate-cell',
          maxWidth: 180,
          width: 180,
        },
        {
          headerComponentFramework: MotifTableHeaderRendererComponent,
          headerName: 'Triggered By',
          field: 'created_by',
          filter: false,
          flex: 2,
          unSortIcon: true,
          valueGetter: (params: any) => {
            return params.data && params.data.created_by
              ? params.data.created_by
              : '';
          },
            cellRenderer: MotifTableCellRendererComponent,
            cellRendererParams: {
              ngTemplate: this.createdByTemplate,
            },
          width: 200,
        },
        {
          headerComponentFramework: MotifTableHeaderRendererComponent,
          headerName: 'Last Triggered Date',
          field: 'created_at',
          filter: false,
          flex: 3,
          unSortIcon: false,
            cellRenderer: MotifTableCellRendererComponent,
            cellRendererParams: {
              ngTemplate: this.createdAtTemplate,
            },
          cellStyle: { 'padding-right': '0px', paddingLeft: '8px' },
          width: 160,
          minWidth: 160,
          maxWidth: 160,
        },
        {
          headerComponentFramework: MotifTableHeaderRendererComponent,
          cellRenderer: MotifTableCellRendererComponent,
          cellRendererParams: {
            ngTemplate: this.actionsTemplate,
          },
          headerName: 'Actions',
          field: 'template',
          filter: false,
          flex: 2,
          unSortIcon: false,
          pinned: 'right',
          maxWidth: 135,
          width: 135,
          cellStyle: { 'border-left-width': '0px' },
        },
      ];
    });
  }

  // Function to get completed_percentage from dataSource based on doc_run_id
  getCompletedPercentageByDocRunId = (docRunId: string): number | null => {
    if (!this.dataSource || !Array.isArray(this.dataSource)) return null;
    const row = this.dataSource.find((d: any) => d.doc_run_id === docRunId);
    return row ? row.completed_percentage : null;
  };
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private service: LoanAiService,
    private layoutService: LayoutService,
    private modal: MotifModal,
    private profileService: ProfileService,
    private mappingResultService: MappingResultService,
  ) {
    this.route.queryParams.subscribe((queryParams) => {
      this.year = queryParams['year'];
      this.quarter = queryParams['quarter'];
      const qpPage = queryParams['page'];
      const qpSearch = queryParams['search'];
      if (qpSearch !== undefined && qpSearch !== null) {
        this.searchQuery = qpSearch;
        this.hadQueryParamSearch = true;
      }
      if (qpPage !== undefined && qpPage !== null) {
        const parsed = parseInt(qpPage, 10);
        if (!isNaN(parsed) && parsed >= 1) {
          const zeroBased = parsed - 1;
          if (this.initialPageIndex === null) {
            this.initialPageIndex = zeroBased;
          }
        }
      }
    });
  }

  private attemptRestorePage() {
    if (this.initialPageIndex === null || this.initialPageIndex === undefined) return;
    if (!this.gridApi || !this.gridApi.paginationGetTotalPages) return;
    const totalPages = this.gridApi.paginationGetTotalPages();
    if (!totalPages || totalPages <= 0) return;
    const target = Math.min(this.initialPageIndex, totalPages - 1);
    if (this.gridApi.paginationGetCurrentPage && this.gridApi.paginationGetCurrentPage() !== target) {
      this.gridApi.paginationGoToPage(target);
      this.currentPageIndex = target;
      this.updatePageInUrl(true);
    }
  }

  private updatingUrl = false;
  private updatePageInUrl(silent: boolean = false) {
    if (this.updatingUrl) return;
    this.updatingUrl = true;
    const queryParams: any = { ...this.route.snapshot.queryParams, page: this.currentPageIndex + 1 };
    if (this.searchQuery && this.searchQuery.trim().length > 0) {
      queryParams.search = this.searchQuery.trim();
    } else if (queryParams.search) {
      delete queryParams.search;
    }
    this.router.navigate([], { relativeTo: this.route, queryParams, queryParamsHandling: 'merge', replaceUrl: true })
      .finally(() => {
        this.updatingUrl = false;
        if (silent) {
          return;
        }
      });
  }

  private updateSearchInUrl() {
    if (this.updatingUrl) return;
    this.updatingUrl = true;
    const queryParams: any = { ...this.route.snapshot.queryParams };
    if (this.searchQuery && this.searchQuery.trim().length > 0) {
      queryParams.search = this.searchQuery.trim();
    } else if (queryParams.search) {
      delete queryParams.search;
    }
    this.router.navigate([], { relativeTo: this.route, queryParams, queryParamsHandling: 'merge', replaceUrl: true })
      .finally(() => { this.updatingUrl = false; });
  }

  private stopActionEvent(event?: Event) {
    try {
      event?.preventDefault();
      event?.stopPropagation();
      if (typeof event?.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
    } catch (e) { /* ignore */ }
  }

  goToResultScreen(row: any, event?: Event) {
    if (!event || event.defaultPrevented) {
      return;
    }
    const target = event.target as HTMLElement | null;
    if (!target?.closest?.('.mapping-list-button')) {
      return;
    }
    if (typeof MouseEvent !== 'undefined' && !(event instanceof MouseEvent)) {
      return;
    }
    this.stopActionEvent(event);
    this.router.navigate(['/mapping-result'], {
      queryParams: {
        year: this.year,
        quarter: this.quarter,
        doc_run_id: row.doc_run_id,
        doc_req_id: row.request_id,
        extractionStatus: row.step_status,
        sub_product: row.sub_product_type,
        product: this.client_name || 'Corporate Loan',
        subproduct: row.sub_product_type || 'Loan File Review',
        asset_class: row.asset_class || 'Asset class',
        data_element: row.obligor_name || 'Borrower name',
        page: this.currentPageIndex + 1,
        search: (this.searchQuery && this.searchQuery.trim().length > 0) ? this.searchQuery.trim() : undefined,
      },
    });
  }

  viewDoc(row: any, event?: Event) {
    this.stopActionEvent(event);
    const queryParams: any = {
      page: (this.currentPageIndex != null ? this.currentPageIndex + 1 : undefined),
      search: (this.searchQuery && this.searchQuery.trim().length > 0) ? this.searchQuery.trim() : undefined,
    };
    this.router.navigate([
      '/view-docs',
      row.doc_run_id,
      this.quarter,
      this.year,
        ], {
      queryParams,
      state: {
        obligor_name: row.obligor_name,
        facility_type: row.sub_product_type
      }
    });
  }

  // Persist search across navigation that may drop query params
  private persistSearch() {
    const key = 'view-details-search';
    if (this.searchQuery && this.searchQuery.trim().length > 0) {
      sessionStorage.setItem(key, this.searchQuery.trim());
    } else {
      sessionStorage.removeItem(key);
    }
  }

  private loadPersistedSearch() {
    const key = 'view-details-search';
    const stored = sessionStorage.getItem(key);
    if (stored && stored.trim().length > 0) {
      this.searchQuery = stored.trim();
    }
  }

  updateAsset(val: any, docId: any) {
    this.service
      .updateAsset(this.year, this.quarter, val, docId)
      .subscribe((data) => {
        // Update both the master and displayed lists so bindings detect the change
        if (Array.isArray(this.dataSource)) {
          this.dataSource.forEach((d: any) => {
            if (d.doc_run_id === docId) {
              d.asset_class = val;
            }
          });
          // replace references so OnPush/third-party table picks up changes
          this.dataSource = [...this.dataSource];
        }
        if (Array.isArray(this.displayedDataSource)) {
          this.displayedDataSource.forEach((d: any) => {
            if (d.doc_run_id === docId) {
              d.asset_class = val;
            }
          });
          this.displayedDataSource = [...this.displayedDataSource];
        }
        // Force ag-grid / motif table refresh
        try { this.refreshGridCells(); } catch (e) { /* ignore */ }

        this.checkForAsset(this.dataSource);
        this.checkExtractionInprogress();
      });
  }

  runExtraction(event?: Event) {
    this.stopActionEvent(event);
    this.allAssetAvailable = false;
    this.selectedProduct = false;
    this.extractionInProgress = true;
    this.service.runExtraction(this.year, this.quarter).subscribe((data) => {
      this.attributeReqId = data.request_id;
      // Announce the new request id for ALL obligors involved in the bulk extraction
      try {
        if (Array.isArray(this.dataSource)) {
          this.dataSource.forEach((d: any) => {
            if (d && d.doc_run_id && data.request_id) {
              this.mappingResultService.announceRequestId(d.doc_run_id, data.request_id);
            }
          });
        }
      } catch (e) { /* ignore */ }
      // Update UI immediately to indicate extraction has started
      this.toastType = ToastType.Info;
      this.showToast = true;
      this.toastMessage = 'Extraction process initiated';
      this.isComponentActive = true;
      if (data.obligors && Array.isArray(data.obligors)) {
        data.obligors.forEach((apiObligor: any) => {
          const row = this.dataSource.find(
            (d: any) => d.doc_run_id === apiObligor.doc_run_id
          );
          if (row && apiObligor.created_by) {
            row.created_by = apiObligor.created_by;
          }
        });
      }
      this.getDocRunIdsFromObligors(this.dataSource);
      const docIds = this.dataSource.map((d: any) => d.doc_run_id);
      this.startPolling(data.request_id, docIds);
      setTimeout(() => {
        this.showToast = false;
      }, 3000);
    });
  }

  downloadCsv() {
    if (this.csvDownloading) return;
    this.csvDownloading = true;
    const yearParam = this.year;
    const quarterParam = this.quarter;
    this.service.downloadCsv(yearParam, quarterParam).subscribe(
      (resp: any) => {
        try {
          // Expecting resp to be { file_name, content_type, content_base64 }
          const { file_name, content_type, content_base64 } = resp || {};
          if (!content_base64) throw new Error('No CSV content received');
          // Decode base64 to Uint8Array
          const byteCharacters = atob(content_base64);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: content_type || 'text/csv' });
          // Compose filename as Client_YEAR_QUARTER_filename.csv (e.g., NexBank2026_Q3_obligors_with_missing_categories.csv)
          let filename = file_name || 'obligors_with_missing_categories.csv';
          // Add client name before year and quarter
          let client = (this.client_name || 'client').toString().replace(/[^a-z0-9_-]/gi, '_');
          if (yearParam && quarterParam) {
            filename = `${client}_${yearParam}_${quarterParam}_${filename}`;
          } else if (yearParam) {
            filename = `${client}_${yearParam}_${filename}`;
          } else if (quarterParam) {
            filename = `${client}_${quarterParam}_${filename}`;
          } else {
            filename = `${client}_${filename}`;
          }
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
          // show success toast on successful download
          this.toastType = ToastType.Success;
          this.showToast = true;
          this.toastMessage = 'CSV downloaded successfully';
          setTimeout(() => (this.showToast = false), 3000);
        } catch (e) {
          this.toastType = ToastType.Error;
          this.showToast = true;
          this.toastMessage = 'Failed to download CSV file';
          setTimeout(() => (this.showToast = false), 3000);
        } finally {
          this.csvDownloading = false;
        }
      },
      (err) => {
        this.csvDownloading = false;
        this.toastType = ToastType.Error;
        this.showToast = true;
        this.toastMessage = 'Failed to download CSV file';
        setTimeout(() => (this.showToast = false), 3000);
      }
    );
  }

  runIndividualExtraction(row: any, event?: Event) {
    let _event: any = event;
    try {
      if (_event && typeof (_event as any).preventDefault === 'function') {
        (_event as any).preventDefault();
      }
      if (_event && (typeof (_event as any).stopImmediatePropagation === 'function')) {
        (_event as any).stopImmediatePropagation();
      }
      if (_event && typeof (_event as any).stopPropagation === 'function') {
        (_event as any).stopPropagation();
      }
    } catch (e) { /* ignore */ }

    // Ensure asset class selected before proceeding - 25-05
    try {
      if (!row || !row.asset_class || String(row.asset_class).trim().length === 0) {
        try {
          if (_event && typeof (_event as any).stopPropagation === 'function') {
            (_event as any).stopPropagation();
          }
        } catch (e) { /* ignore */ }
        this.toastType = ToastType.Warning;
        this.showToast = true;
        this.toastMessage = 'Please select Asset Class before running extraction';
        setTimeout(() => { this.showToast = false; }, 3000);
        return;
      }
    } catch (e) { /* ignore */ }

    // If missing required document categories, show a dedicated modal and do not proceed
    try {
      if (row && row.has_missing_categories) {
        const missing = Array.isArray(row.missing_categories) ? row.missing_categories : [];
        // Use a plain in-component modal centered on screen instead of Motif modal
        try {
          this.requiredModalCategories = missing;
          this.requiredModalObligor = row.obligor_name || null;
          this.requiredModalRow = row;
          this.showRequiredDocsModal = true;
        } catch (e) { /* ignore */ }
        return;
      }
    } catch (e) { /* ignore */ }

    // Prevent multiple rapid clicks from opening multiple modals
    if ((this as any)._runIndividualExtractionModalOpen) return;
    (this as any)._runIndividualExtractionModalOpen = true;
    const modelData = {
      message: `Are you sure you want to run extraction for ${row.obligor_name}?`,
      showCancelButton: true,
      confirmButtonText: 'Run Extraction',
    };
    // pass modelData to the modal
    const modelConfirm = this.modal.open(ConfirmCommonComponent, {
      data: modelData,
      hasBackdrop: true,
      disableClose: true,
    });

    modelConfirm.afterClosed().subscribe((result: any) => {
      // if (btnRef && btnRef.blur) {
      //   btnRef.blur();
      // }
      (this as any)._runIndividualExtractionModalOpen = false;
      if (result) {
        this.allAssetAvailable = false;
        this.selectedProduct = false;
        this.extractionInProgress = true;

        // Update the UI to show extraction is in progress
        const rowToUpdate = this.dataSource.find(
          (d: any) => d.doc_run_id === row.doc_run_id
        );
        if (rowToUpdate) {
          rowToUpdate.step_status = 'IN_PROGRESS';
          rowToUpdate.created_by = this.profileService.getUserEmail();
          this.dataSource = [...this.dataSource];
        }

        this.toastType = ToastType.Success;
        this.showToast = true;
        this.toastMessage = `Successfully started extraction for ${row.obligor_name}`;
        setTimeout(() => {
          this.showToast = false;
        }, 3000);

        this.service
          .runSingleJobExtraction(this.year, this.quarter, row.doc_run_id, row.obligor_name, row.sub_product_type)
          .subscribe((data) => {
            this.attributeReqId = data.request_id;
            // Announce new request id for this doc_run_id so mapping-result can switch
            try { this.mappingResultService.announceRequestId(row.doc_run_id, data.request_id); } catch (e) {}
            this.isComponentActive = true;
            // Update created_by for this row if available from API response
            if (data.obligors && Array.isArray(data.obligors)) {
              const apiObligor = data.obligors.find(
                (o: any) => o.doc_run_id === row.doc_run_id
              );
              if (apiObligor && apiObligor.created_by && rowToUpdate) {
                rowToUpdate.created_by = apiObligor.created_by;
              }
            }
            try { this.removeDocFromPolling(row.doc_run_id); } catch (e) { /* ignore */ }
            this.startPolling(data.request_id, [row.doc_run_id]);
          });
      }
    });
  }

  closeRequiredDocsModal() {
    this.showRequiredDocsModal = false;
    this.requiredModalCategories = [];
    this.requiredModalObligor = null;
    this.requiredModalRow = null;
  }

  onRunAnywayFromRequiredModal() {
    const row = this.requiredModalRow;
    this.showRequiredDocsModal = false;
    this.requiredModalCategories = [];
    this.requiredModalObligor = null;
    this.requiredModalRow = null;

    if (!row) {
      this.closeRequiredDocsModal();
      return;
    }

    // Directly run extraction without confirmation popup
    this.runIndividualExtractionTriggered(row, false);
  }

  checkForAsset(dataSource: any[]) {
    if (!Array.isArray(dataSource) || !Array.isArray(this.dataSource)) {
      this.allAssetAvailable = false;
      return;
    }
    const allAsset = dataSource.filter(
      (objs: any) => objs?.asset_class != null && String(objs.asset_class).trim().length > 0
    );
    this.allAssetAvailable = allAsset.length === this.dataSource.length;
  }

  productSelected(val: any) {
        this.selectedProductValue = val;
    // this.selectedProduct = !!val;
    this.selectedProduct = true;
    // Re-check asset and extraction status when product changes
    this.checkForAsset(this.dataSource);
    this.checkExtractionInprogress();
  }

  goBack() {
    if (this.searchQuery && this.searchQuery.trim().length > 0) {
      this.searchQuery = '';
      this.applyFilter();
      this.persistSearch();
      this.updateSearchInUrl();
      setTimeout(() => this.router.navigate(['/']), 0);
      return;
    }
    this.router.navigate(['/']);
  }

  onCellValueChanged(event: CellValueChangedEvent): void {
    this.updatedRow = event.data;
    this.newAssetValue = event.newValue;
    this.confirmationModal = true;
  }

  callUpdateAPI() {
    this.confirmationModal = false;
    this.updateAsset(this.newAssetValue, this.updatedRow.doc_run_id);
    // Show success toast
    this.toastType = ToastType.Success;
    this.showToast = true;
    this.toastMessage = `Successfully updated Asset Class for ${this.updatedRow.obligor_name}`;
    setTimeout(() => {
      this.showToast = false;
    }, 3000);
    // Make sure polling is resumed after cell value is updated
    this.resumePolling();
  }

  getProgress(row: any): number {
      const status = row.step_status?.trim().toLowerCase();
      if (status === 'completed') {
        return 100;
      } else if (status === 'failed') {
        return row.completed_percentage != null ? row.completed_percentage : 0;
      } else if (row.completed_percentage != null) {
        return row.completed_percentage;
      } else {
        return 0;
      }
    }

  getProgressLabel(row: any): string {
      const status = row.step_status?.trim().toLowerCase();
      if (status === 'completed') {
        return '100% Complete';
      } else if (status === 'failed') {
        return 'Failed';
      } else if (status === 'cancelled') {
        return 'Cancelled';
      } else if (this.getProgress(row) === 0) {
        return 'Not Started';
      } else {
        return `${this.getProgress(row)}% Complete`;
      }
  }

  private _stopExtractionModalOpen: boolean = false;
  openStopExtractionModal(row: any, btnRef?: any, event?: Event) {
    let _event: any = event;
    if (! _event && btnRef && (typeof (btnRef as any).stopPropagation === 'function' || (btnRef as any) instanceof Event)) {
      _event = btnRef as Event;
      btnRef = undefined;
    }
    try {
      if (_event && (typeof (_event as any).stopImmediatePropagation === 'function')) {
        (_event as any).stopImmediatePropagation();
      }
      if (_event && typeof (_event as any).stopPropagation === 'function') {
        (_event as any).stopPropagation();
      }
    } catch (e) { /* ignore */ }

    if ((this as any)._stopExtractionModalOpen) return;
    (this as any)._stopExtractionModalOpen = true;

    const modelData = {
      message: `Are you sure you want to stop extraction for ${row.obligor_name}?`,
      showCancelButton: true,
      confirmButtonText: 'Stop Extraction',
    };

    const modelConfirm = this.modal.open(ConfirmStopComponent, {
      data: modelData,
      hasBackdrop: true,
      disableClose: true,
    });

    modelConfirm.afterClosed().subscribe((result: any) => {
      (this as any)._stopExtractionModalOpen = false;
      if (!result) return;

      // Call stop Databricks extraction API (service handles request_id)
      this.service.stopDatabricksJobExtraction(row.request_id, row.doc_run_id).subscribe(
        (resp: any) => {
          try {
            // If API returns cancelled list, update corresponding rows
            if (resp && Array.isArray(resp.cancelled)) {
              resp.cancelled.forEach((c: any) => {
                const target = this.dataSource.find((d: any) => d.doc_run_id === c.doc_run_id);
                if (target) {
                  target.step_status = resp.step_status || 'CANCELLED';
                  // Optionally store databricks_run_id on the row if present
                  if (typeof c.databricks_run_id !== 'undefined') {
                    target.databricks_run_id = c.databricks_run_id;
                  }
                  // stop polling for this doc
                  try { this.removeDocFromPolling(c.doc_run_id); } catch (e) { /* ignore */ }
                }
              });
              this.dataSource = Array.isArray(this.dataSource) ? [...this.dataSource] : [];
              this.displayedDataSource = Array.isArray(this.dataSource) ? [...this.dataSource] : [];
              this.refreshGridCells();
              this.checkExtractionInprogress();
            }

            this.toastType = ToastType.Success;
            this.showToast = true;
            this.toastMessage = `Stopped extraction for ${row.obligor_name}`;
            setTimeout(() => { this.showToast = false; }, 3000);
          } catch (e) {
            // ignore UI update errors
          }

          // Refresh the view-data from the server so the UI reflects the latest state
          try {
            this.service.viewDetails(this.year, this.quarter).subscribe((data: any) => {
              this.dataSource = Array.isArray(data?.obligors) ? data.obligors : [];
              this.displayedDataSource = Array.isArray(this.dataSource) ? [...this.dataSource] : [];
              this.totalCount = this.displayedDataSource.length;
              this.getDocRunIdsFromObligors(this.dataSource);
              this.checkForAsset(this.dataSource);
              this.checkExtractionInprogress();
              this.refreshGridCells();
            }, () => { /* ignore viewDetails errors */ });
          } catch (e) { /* ignore */ }
        },
        (err) => {
          this.toastType = ToastType.Error;
          this.showToast = true;
          this.toastMessage = `Failed to stop extraction for ${row.obligor_name}`;
          setTimeout(() => { this.showToast = false; }, 3000);
        }
      );
    });
  }

  /**
   * Remove a doc_run_id from any active polling subscriptions so polling stops for it.
   */
  private removeDocFromPolling(docRunId: string) {
    try {
      const toRemove: string[] = [];
      this.pollingMap.forEach(({ subscription, docIds }, requestId) => {
        if (docIds && docIds.has(docRunId)) {
          docIds.delete(docRunId);
        }
        if (!docIds || docIds.size === 0) {
          try { subscription.unsubscribe(); } catch (e) { /* ignore */ }
          toRemove.push(requestId);
        }
      });
      toRemove.forEach((rid) => this.pollingMap.delete(rid));
      this.clearInProgressTracking(docRunId);
    } catch (e) { /* ignore */ }
  }

  onStopButtonClick(row: any, event?: Event) {
    try {
      if (event && (typeof (event as any).stopPropagation === 'function')) {
        (event as any).stopPropagation();
      }
    } catch (e) { /* ignore */ }

    const progress = this.getProgress(row) || 0;
    if (progress >= 80) {
      this.toastType = ToastType.Warning;
      this.showToast = true;
      this.toastMessage = 'Cannot stop after 80%';
      setTimeout(() => { this.showToast = false; }, 3000);
      return;
    }
    // if allowed, delegate to the existing modal opener
    this.openStopExtractionModal(row, undefined, event);
  }
}
